/// <amd-module name="Dashboards/RateLimiter/Constants" />

/**
 *  The Constants here are defined from RASP's platform layer.
 *  Below is a sample snippet of what the data can look like in practice. It only shows up at ~67% utilization, which is the key concern for throttling until they can expose a clean cut ratio of total available vs used capacity.
 *   x-ratelimit-delay: 0.094
 *   x-ratelimit-limit: 0
 *   x-ratelimit-remaining: 0
 *   x-ratelimit-reset: 1544675138
 *   x-ratelimit-resource: TFS/Short
 */
export class RateLimitHttpHeaderConstants {
    public static VssRateLimitResource = "X-RateLimit-Resource";
    public static VssRateLimitDelay = "X-RateLimit-Delay";
    public static VssRateLimitLimit = "X-RateLimit-Limit";
    public static VssRateLimitRemaining = "X-RateLimit-Remaining";
    public static VssRateLimitReset = "X-RateLimit-Reset";
    public static RetryAfter = "Retry-After";
}
